import { useState } from "react";
import { useGetGalleryApproval } from "./api";
import EventCard from "./component/EventCard";

const AdminGalleryApproval = () => {
  const { approvalGallery } = useGetGalleryApproval();
  const [expandedEvents, setExpandedEvents] = useState<Set<string>>(
    new Set(approvalGallery?.map((event) => event.event_id))
  );

  const toggleEventExpansion = (eventId: string) => {
    setExpandedEvents((prev) => {
      const newSet = new Set(prev);
      newSet.has(eventId) ? newSet.delete(eventId) : newSet.add(eventId);
      return newSet;
    });
  };

  return (
    <div className="mt-[5vh] w-full h-[95vh] p-5 md:p-10 2xl:p-14 overflow-auto flex flex-col gap-2 xl:gap-3">
      <h1 className="text-2xl font-montserrat font-semibold">Admin Image Approval</h1>
      {approvalGallery?.map((event) => (
        <EventCard
          key={event.event_id}
          event={event}
          isExpanded={expandedEvents.has(event.event_id)}
          toggleExpanded={() => toggleEventExpansion(event.event_id)}
        />
      ))}
    </div>
  );
};

export default AdminGalleryApproval;
